import { Drawer_Content_default } from "./chunk-DTMEVGSF.js";
import { Drawer_Header_default } from "./chunk-SKRXEL7A.js";
import { Drawer_default } from "./chunk-3FQIK2D6.js";

// src/components/Drawer/index.ts
var DrawerComponent = Drawer_default;
DrawerComponent.Header = Drawer_Header_default;
DrawerComponent.Header.displayName = "Drawer.Header";
DrawerComponent.Content = Drawer_Content_default;
DrawerComponent.Content.displayName = "Drawer.Content";
export { DrawerComponent };